var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 413.5 430.6",
    style: {
      enableBackground: "new 0 0 413.5 430.6"
    },
    width: 25,
    height: 25,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M290.4,392c-17.4-1.6-32.4-5.6-47.1-11c-34.9-12.9-65.8-32.5-94.5-55.9c-40.1-32.8-73.6-71.3-98.9-116.6 c-13.2-23.6-23.1-48.5-27.8-75.4c-1.4-8-0.7-15.1,3.7-22.2c16.5-26.3,35.5-50.3,59.3-70.4c1.5-1.3,3.2-2.4,4.8-3.5 c9.9-7.1,17.9-5.3,27.5,2.2c1.3,1,2.4,2.2,3.3,3.5c16.4,23.2,32.3,46.8,44.3,72.7c1.8,3.9,3.1,8.1,4.4,12.3 c2.1,6.7,0.8,13.1-3.9,18.2c-4.6,5.1-9.8,9.5-14.8,14.2c-1.3,1.2-2.7,2.3-4,3.4c-8.2,6.9-8.4,7-4.1,17 c18.7,43.7,50.2,74.2,94.5,91.6c4,1.6,6.4,1.1,9.1-2.3c5.1-6.5,10.6-12.6,16.2-18.7c7.7-8.5,17.1-11.2,27.7-6.3 c12.2,5.7,24.4,11.4,35.9,18.2c14.6,8.7,28.6,18.6,42.8,28.1c5.7,3.8,9.1,9.4,10.9,16.1c1,3.9,0.7,7.5-1.3,10.8 c-2.4,4-4.8,8.2-7.9,11.7c-20.7,23.5-44.6,43.1-71.7,58.7C295.8,390.5,292.2,391.3,290.4,392z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.1114acc71f908f3562d6034534af7652.svg";
export { ForwardRef as ReactComponent };